// extracted by mini-css-extract-plugin
export default {"container":"ImageSlider_container__SgaFr","slider":"ImageSlider_slider__NUdm0","slide":"ImageSlider_slide__8Nk57"};